import { Company } from "../model/Companies";
import axiosCilent from "./axiosClient";
import { Result } from "../model/Result";
import jwtApi from "./Jwt.api";
import { auth } from "../firebase";

export const requestCompaniesAdd = async (company:Company): Promise<Result> => {
  try {
    const currentUser = auth.currentUser;
    return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
      .then(async (_) => {
        const response = await axiosCilent.post('add', company);
        return response.data;
      })
      .catch((rejects) => {
        return {success: false, data: rejects};
      });
  } catch (error) {
    return Promise.reject({ success: false, error });
  }
};

// ボランティア依頼APIリクエスト
export const requestMatchingAdd = async (
  tenantId: string,
  hash: string,
  contents: string,
  area: string
): Promise<Result> => {
  try {
    const response = await axiosCilent.post(`matchingRequestAdd/${tenantId}`, {hash, contents, area});
    return response.data;
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// ボランティア依頼内容取得APIリクエスト
export const requestMatchingGet = async (tenantId: string, hash: string, requestId: string)
  : Promise<Result> => {
  try{
    const response = await axiosCilent.get(`matchingRequestGet/${tenantId}/${requestId}/${hash}`);
    return response.data;
  } catch (error: any) {
    return Promise.reject({success: false, data: error})
  }
};

// ボランティア支援表明
export const requestMatchingReceipt = async (tenantId: string, hash: string, requestId: string)
  :Promise<Result> => {
    try {
      const response = await axiosCilent.post(`matchingReceipt/${tenantId}/${requestId}/${hash}`);
      return response.data;
    } catch (err: any) {
      return Promise.reject({ success: false, data: err });
    }
  }

  // オプション管理の権限取得を行うAPIリクエスト
  export const requestGetOptionAuth = async (
    tenantId: string,
    targetNo: number,
  ): Promise<Result> =>  {
    try {
      const currentUser = auth.currentUser;
      return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
        .then(async (_) => {
          const response = await axiosCilent.post(`getOptionAuth/${tenantId}/${targetNo}`);
          return response.data;
        })
        .catch((rejects) => {
          return {success: false, data: rejects};
        });
    } catch (error: any) {
      console.log(error)
      return {success: false, data: error};
    }
  };

  // 利用者IDカードの権限取得を行うAPIリクエスト
  export const requestIdCardAuth = async (
    tenantId: string,
  ): Promise<Result> =>  {
    try {
      const currentUser = auth.currentUser;
      return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
        .then(async (jwt) => {
          const response = await axiosCilent.post(`getIdcardAuth/${tenantId}`, {}, {
            headers: {
              'Authorization': jwt.data
            }
          });
          return response.data;
        })
        .catch((rejects) => {
          return {success: false, data: rejects};
        });
    } catch (error: any) {
      console.log(error)
      return {success: false, data: error};
    }
  };

    // ポイント管理の権限取得を行うAPIリクエスト
    export const requestManagePointAuth = async (
      tenantId: string,
    ): Promise<Result> =>  {
      try {
        const currentUser = auth.currentUser;
        return await jwtApi.requestGetJwt(currentUser?.email!, currentUser?.uid!, currentUser?.tenantId!)
          .then(async (jwt) => {
            const response = await axiosCilent.post(`getPointManageAuth/${tenantId}`, {}, {
              headers: {
                'Authorization': jwt.data
              }
            });
            return response.data;
          })
          .catch((rejects) => {
            return {success: false, data: rejects};
          });
      } catch (error: any) {
        console.log(error)
        return {success: false, data: error};
      }
    };
  

// helper functions
